<script setup>
import cmsApiDriveService from "@/services/http/api-drive/cms";
import { loadPageWithLoader } from "@/utils/webpack-helper";
import { useTrackingPage } from "@/mixins/tracking/all-pages";
import { useContextStore } from "@/store/context";
import { useMagasinStore } from "@/store/magasin";
import { useAxiosHelper } from "@/utils/axios-helper";

const { layout } = storeToRefs(useContextStore());
const { trackPage } = useTrackingPage();
const { id: magasinId } = useMagasinStore();
const { query, path } = useRoute();
const { getHead, throwIfAxiosError } = useAxiosHelper();
const component = computed(() => {
  return loadPageWithLoader(
    lazyComponents[
      `/components/pages/infos-et-services/page-contenu/${layout.value}.vue`
    ]
  );
});

onMounted(() => {
  trackPage(trackingCodes.PAGETYPE.legal);
});

const params = {};
params.magasinId = magasinId;
if (query.preview) {
  params.preview = query.preview;
}
if (query.displayMode) {
  // Paramètre à passer à l'api pour l'app mobile
  params.displayMode = query.displayMode;
}

const { data: response, error } = await useAsyncData((app) =>
  app.$apiDrive.use(cmsApiDriveService).fetchContent(path, params)
);

throwIfAxiosError(error);

const conf = useRuntimeConfig();

useHead(() => {
  return {
    ...getHead(response)
  };
});
</script>

<template>
  <component
    :is="component"
    :context="'legal'"
    :cms-reponse="response"
  />
</template>
